import { Box, styled } from '@planne-software/uni/mui/material';
import { uni } from '@planne-software/uni/v2';

import { breakpoints } from '@src/common/breakpoints';
import { uniTypography } from '@src/fonts/typography/uniTypography';

export const AccountCardRoot = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('spacing-24-16'),
  width: '100%',
  padding: uni('padding-content'),
  borderRadius: uni('border-radius-md'),
  border: `1px solid ${uni('border-static-content-default')}`,
  backgroundColor: uni('bg-static-content-default'),
  [`@media (max-width: ${breakpoints.smallTablet})`]: {
    borderRadius: uni('border-radius-sm'),
  },
}));

export const AccountCardHeader = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  gap: uni('scale-200'),
}));

export const AccountCardLabel = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: uni('scale-200'),
  color: uni('fg-success-default-rest'),
}));

export const AccountCardTitle = styled('p')`
  ${uniTypography('text-lg', 'medium')}
  color: ${uni('fg-neutral-static-default-heading')};
  margin: 0;
`;

export const AccountCardEmail = styled('p')`
  ${uniTypography('text-md', 'regular')}
  color: ${uni('fg-neutral-static-default-body')};
  margin: 0;
  word-break: break-word;

  @media (max-width: ${breakpoints.smallTablet}) {
    ${uniTypography('text-sm', 'regular')}
  }
`;

export const AccountCardEditButton = styled('button')`
  ${uniTypography('text-sm', 'semibold')}
  padding: 0;
  border: none;
  background: transparent;
  color: ${uni('fg-primary-default-rest')};
  text-decoration: none;
  cursor: pointer;
`;
